import { useState, useRef, useEffect } from "react";
import { exportToPDF, exportToExcel } from "./ExportUtils";
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from "@headlessui/react";
import { ExclamationTriangleIcon, ArrowDownTrayIcon, DocumentArrowDownIcon } from "@heroicons/react/24/outline";
import { DocumentTextIcon } from "@heroicons/react/24/solid";

export default function ExportButton({ selectedRows, produits }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [errorDialogOpen, setErrorDialogOpen] = useState(false);
  const menuRef = useRef(null);

  const handleExport = (format) => {
    if (selectedRows.length === 0) {
      setMenuOpen(false);
      setErrorDialogOpen(true);
      return;
    }

    const dataToExport = selectedRows.map((id) =>
      produits.find((prod) => prod._id === id)
    );

    if (!dataToExport.length) {
      setMenuOpen(false);
      setErrorDialogOpen(true);
      return;
    }

    if (format === "pdf") {
      exportToPDF(dataToExport);
    } else if (format === "excel") {
      exportToExcel(dataToExport);
    }

    setMenuOpen(false);
  };

  // Fermer le menu si on clique en dehors
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <>
      {/* Bouton principal */}
      <div className="relative inline-block text-left" ref={menuRef}>
        <button
          onClick={() => setMenuOpen((prev) => !prev)}
          className="inline-flex items-center gap-2 rounded-md bg-green-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500"
        >
          <ArrowDownTrayIcon className="h-5 w-5" />
          Exporter
        </button>

        {/* Dropdown Menu */}
        {menuOpen && (
          <div className="absolute right-0 mt-2 w-52 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 z-20">
            <div className="py-1">
              <button
                onClick={() => handleExport("pdf")}
                className="flex w-full items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
              >
                <DocumentTextIcon className="h-5 w-5 text-red-500 mr-2" />
                Exporter en PDF
              </button>
              <button
                onClick={() => handleExport("excel")}
                className="flex w-full items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
              >
                <DocumentArrowDownIcon className="h-5 w-5 text-green-600 mr-2" />
                Exporter en Excel
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Modal d'erreur */}
      <Dialog open={errorDialogOpen} onClose={() => setErrorDialogOpen(false)} className="relative z-50">
        <DialogBackdrop className="fixed inset-0 bg-gray-500/75 transition-opacity" />
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          <DialogPanel className="bg-white rounded-lg shadow-xl transform transition-all w-full max-w-md">
            <div className="p-6">
              <div className="flex items-start">
                <div className="mx-auto flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                  <ExclamationTriangleIcon className="h-6 w-6 text-red-600" aria-hidden="true" />
                </div>
                <div className="ml-4">
                  <DialogTitle as="h3" className="text-lg font-semibold text-gray-900">
                    Erreur d'exportation
                  </DialogTitle>
                  <div className="mt-2">
                    <p className="text-sm text-gray-500">
                      Veuillez sélectionner au moins une ligne avant d'exporter les données.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse">
              <button
                onClick={() => setErrorDialogOpen(false)}
                className="inline-flex w-full justify-center rounded-md bg-red-600 px-4 py-2 text-sm font-semibold text-white hover:bg-red-500 sm:ml-3 sm:w-auto"
              >
                OK
              </button>
            </div>
          </DialogPanel>
        </div>
      </Dialog>
    </>
  );
}
